import axios from 'axios';

export default {
  // Aktiiviset työmenetelmät attribuuttimäärittelyineen.
  async getWorkMethods() {
    return await axios({
      url: '/api/tenant/work-method',
    }).then(r => r.data);
  },
  // Hallintanäytön kutsut (vaativat tenant_tech_admin-roolin).
  async getAllWorkMethodsAdmin() {
    return await axios({
      url: '/api/tenant/work-method-admin',
    }).then(r => r.data);
  },
  async createWorkMethod(data) {
    return await axios({
      method: 'post',
      url: '/api/tenant/work-method-admin',
      data,
    }).then(r => r.data);
  },
  async updateWorkMethod(id, data) {
    return await axios({
      method: 'put',
      url: `/api/tenant/work-method-admin/${id}`,
      data,
    }).then(r => r.data);
  },
  async createAttributeDef(methodId, data) {
    return await axios({
      method: 'post',
      url: `/api/tenant/work-method-admin/${methodId}/attribute`,
      data,
    }).then(r => r.data);
  },
  async updateAttributeDef(defId, data) {
    return await axios({
      method: 'put',
      url: `/api/tenant/work-method-admin/attribute/${defId}`,
      data,
    }).then(r => r.data);
  },
  async reorderAttributeDefs(methodId, orderedIds) {
    return await axios({
      method: 'put',
      url: `/api/tenant/work-method-admin/${methodId}/attribute-order`,
      data: orderedIds,
    }).then(r => r.data);
  },
  async deleteAttributeDef(defId) {
    return await axios({
      method: 'delete',
      url: `/api/tenant/work-method-admin/attribute/${defId}`,
    }).then(r => r.data);
  },
};
